import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2206a320"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "far fa-filter" }, null, -1 /* HOISTED */));
const _hoisted_2 = {
    key: 0,
    class: "dropdown-loading"
};
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Loading...", -1 /* HOISTED */));
const _hoisted_4 = [
    _hoisted_3
];
import { ElDropdown, ElDropdownMenu, ElDivider } from "element-plus";
import { ref, computed } from "vue";
import Button from "../../ui/Button.vue";
import DropdownItemCheckbox from "../../ui/dropdown/DropdownItemCheckbox.vue";
import Session from "js/Session";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ComponentDuplicationCandidateFilterMenu',
    props: {
        availableClientIds: {},
        componentGranters: {},
        selectedClientIds: {},
        showAll: { type: Boolean },
        isLoading: { type: Boolean }
    },
    emits: ["update:selectedClientIds", "update:showAll"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const session = Session.getInstance();
        const isSuperUser = session.isSuperUser();
        const currentClientId = session.getClientId();
        const currentClientName = session.getClientName();
        const isDropdownVisible = ref(false);
        const onVisibleChange = (visible) => {
            isDropdownVisible.value = visible;
        };
        const emit = __emit;
        const isSelected = (clientId) => {
            return props.selectedClientIds.includes(clientId);
        };
        const isCurrentClientAvailable = computed(() => {
            return (currentClientId && props.availableClientIds.includes(currentClientId));
        });
        const currentClientDisplayName = computed(() => {
            const currentClientGranter = props.componentGranters.find((granter) => granter.client_id === currentClientId);
            if (currentClientGranter) {
                return (currentClientGranter.client_name ||
                    currentClientGranter.client_short_name ||
                    currentClientId);
            }
            return currentClientName || currentClientId;
        });
        const otherGranters = computed(() => {
            return props.componentGranters.filter((granter) => granter.client_id !== currentClientId);
        });
        const toggleClientId = (clientId) => {
            if (isSelected(clientId)) {
                emit("update:selectedClientIds", props.selectedClientIds.filter((id) => id !== clientId));
            }
            else {
                emit("update:selectedClientIds", [
                    ...props.selectedClientIds,
                    clientId,
                ]);
            }
        };
        const toggleShowAll = () => {
            emit("update:showAll", !props.showAll);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(ElDropdown), {
                trigger: "click",
                "hide-on-click": "",
                "popper-class": "list list--drop-down list--drop-down--modern",
                placement: "bottom-end",
                onVisibleChange: onVisibleChange
            }, {
                dropdown: _withCtx(() => [
                    _createVNode(_unref(ElDropdownMenu), null, {
                        default: _withCtx(() => [
                            (_ctx.isLoading)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    (isCurrentClientAvailable.value)
                                        ? (_openBlock(), _createBlock(DropdownItemCheckbox, {
                                            key: 0,
                                            label: currentClientDisplayName.value,
                                            "model-value": isSelected(_unref(currentClientId)),
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (toggleClientId(_unref(currentClientId))))
                                        }, null, 8 /* PROPS */, ["label", "model-value"]))
                                        : _createCommentVNode("v-if", true),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(otherGranters.value, (granter) => {
                                        return (_openBlock(), _createBlock(DropdownItemCheckbox, {
                                            key: granter.client_id,
                                            label: granter.client_name ||
                                                granter.client_short_name ||
                                                granter.client_id,
                                            "model-value": isSelected(granter.client_id),
                                            "onUpdate:modelValue": ($event) => (toggleClientId(granter.client_id))
                                        }, null, 8 /* PROPS */, ["label", "model-value", "onUpdate:modelValue"]));
                                    }), 128 /* KEYED_FRAGMENT */))
                                ], 64 /* STABLE_FRAGMENT */)),
                            (_unref(isSuperUser))
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                    _createVNode(_unref(ElDivider)),
                                    _createVNode(DropdownItemCheckbox, {
                                        label: 'Show All',
                                        "model-value": _ctx.showAll,
                                        "onUpdate:modelValue": toggleShowAll
                                    }, null, 8 /* PROPS */, ["model-value"])
                                ], 64 /* STABLE_FRAGMENT */))
                                : _createCommentVNode("v-if", true)
                        ]),
                        _: 1 /* STABLE */
                    })
                ]),
                default: _withCtx(() => [
                    _createVNode(Button, {
                        shape: 'square',
                        level: 'menu',
                        "is-active": isDropdownVisible.value,
                        onClick: _cache[0] || (_cache[0] = ($event) => (isDropdownVisible.value = true))
                    }, {
                        default: _withCtx(() => [
                            _hoisted_1
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["is-active"])
                ]),
                _: 1 /* STABLE */
            }));
        };
    }
});
